import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage';

interface TimeFilterProps {
    value: string;
    onChange: (value: string) => void;
}

export const TimeFilter: React.FC<TimeFilterProps> = ({ value, onChange }) => {
    const { t, isRTL } = useLanguage();

    const options = [
        { value: 'day', label: t('timeFilter.day') },
        { value: 'week', label: t('timeFilter.week') },
        { value: 'month', label: t('timeFilter.month') },
        { value: 'year', label: t('timeFilter.year') }
    ];

    return (
        <div className={`flex items-center ${isRTL ? 'space-x-reverse' : ''} space-x-2`}>
            {options.map(option => (
                <button
                    key={option.value}
                    className={`px-3 py-1 text-sm rounded-md transition-colors ${
                        value === option.value
                            ? 'bg-indigo-600 text-white'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};